export const CHART7_REQUEST = "CHART7_REQUEST";
export const CHART7_SUCCESS = "CHART7_SUCCESS";
export const CHART7_FAILURE = "CHART7_FAILURE";
